<div #navContainer class="pnyc-navigation-panel">

    <!-- <div class="pnyc-navigation-panel-bubble" #bubble>
    </div> -->

    @for (item of items(); track item.id) {
        <div class="pnyc-navigation-panel-slot" #slot
            [class.pnyc-navigation-panel-slot--active]="activeItemId() === item.id" (click)="onItemClicked(item)">

            @if (item.template) {
                <ng-container [ngTemplateOutlet]="item.template" />
            } @else {
                <div class="pnyc-navigation-panel-btn">

                    @if (item.icon !== '') {
                        <pnyc-icon class="pnyc-navigation-panel-btn-icon" [iconName]="item.icon"
                            [pnycBadge]="item.badge" [pnycBadgeAlert]="item.badge"
                            [pnycBadgeCountAlertLimit]="badgeLimit()">
                        </pnyc-icon>
                    }

                    @if (item.name !== '') {
                        <div class="pnyc-navigation-panel-btn-text">{{ item.name }}</div>
                    }

                </div>
            }

        </div>
    }
</div>